module.exports = __webpack_public_path__ + "img/coming-soon-dark.0f307440.svg";